import { ContentMain } from 'shared/styles/components';
import styled from 'styled-components';

export const LegalTitleMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  font-size: 14px;
  font-weight: 500;
  font-style: italic;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const LegalPostContent = styled(ContentMain)`
  margin-bottom: 56px;
  padding: 0 16px;

  .divider {
    margin-top: 56px;
    border-top: 2px solid ${({ theme }) => theme.colors.border};
  }

  .underline {
    text-decoration: underline;
  }

  a.appendix {
    color: ${({ theme }) => theme.colors.textPrimary};
    text-decoration: underline;
  }

  b {
    color: ${({ theme }) => theme.colors.textEmphasis};
  }

  h1 {
    margin-top: 40px;
    color: ${({ theme }) => theme.colors.textEmphasis};
    font-family: ${({ theme }) => theme.fontFamily.display};
  }

  h2 {
    margin-top: 32px;
    color: ${({ theme }) => theme.colors.textEmphasis};
    font-size: 24px;
    font-family: ${({ theme }) => theme.fontFamily.display};
    font-weight: 500;

    &.appendix {
      font-style: italic;
    }
  }

  p {
    margin-top: 32px;
    font-size: 18px;
  }

  table {
    margin: 0 auto;
    width: 100%;
    border-collapse: collapse;

    &.support {
      table-layout: fixed;

      td {
        text-align: left;
      }
    }

    th,
    td {
      padding: 8px;
      border: 2px solid ${({ theme }) => theme.colors.border};
      text-align: center;
    }
    th {
      font-weight: bold;
    }
  }

  ul {
    margin: 32px 0;

    li {
      margin-top: 8px;
      list-style-type: '— ';

      ul {
        margin: 8px 0;
      }
    }
  }
`;
